import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const countriesFilterMixin = {
  data() {
    return {
      filteredCountries: [],
    };
  },
  watch: {
    countries: {
      immediate: true,
      handler() {
        this.filteredCountries = this.countries;
      },
    },
  },
  methods: {
    countriesFilterMethod(query) {
      this.filteredCountries = searchWithDiacritics(query, this.countries, ['name']);
    },
    handleCountriesVisibleChange() {
      setTimeout(() => {
        this.filteredCountries = this.countries;
      }, 50);
    },
  },
};
